
import React from 'react'
import {Route,Switch} from 'react-router-dom'
import Entry from '../UC/Entry'
const UC_Module =({match})=>(
    <Switch>
        <Route path={`${match.url}/Entry`} component={Entry}  /> 
    </Switch>
)
export default UC_Module;